/*eslint-disable*/
export const messages = {
  "Cancel": "取消",
  "Change theme": "更改主题",
  "Clear chat": "清除聊天",
  "Clear chat history": "清除聊天历史",
  "Connecting...": "正在连接...",
  "Continue": "继续",
  "Decrease font size": "减小字体大小",
  "Disclaimer": "免责声明",
  "Enter your message...": "输入您的消息...",
  "Type your message...": "输入您的消息...",
  "Error": "错误",
  "Font size": "字体大小",
  "Increase font size": "增加字体大小",
  "Language": "语言",
  "MJ Lab": "MJ 实验室",
  "Reset font size": "重置字体大小",
  "Respond time: {time}s": "响应时间：{time}秒",
  "Response time:": "响应时间：",
  "Send": "发送",
  "Settings": "设置",
  "Support the project": "支持项目",
  "System": "系统",
  "Theme": "主题",
  "Thinking...": "思考中...",
  "Toggle theme": "切换主题",
  "Welcome to {{name}} by MJ": "欢迎使用 MJ 的 {{name}}",
  "You asked:": "您询问：",
  
  // Headers
  "Labor Law Expert": "劳动法专家",
  "by MJ": "由 MJ 提供",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "您好，我是 {{name}}，由 MJ 开发的 AI 助手。",
  "I am expert in labor laws and regulations for Saudi Arabia.": "我是沙特阿拉伯劳动法律和法规方面的专家。",
  "Ask me a question, and I will gladly answer you.": "请向我提问，我将很乐意为您解答。",
  "Do not share confidential data.": "请勿分享机密数据。",
  "I am powered using": "我由以下技术提供支持",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**免责声明：** {{name}} 是一个实验性 AI 助手，旨在使用沙特劳动法律和法规的数据进行回应，避免假设或不准确性。我对其行为或回应的正确性不负责任。",
  
  // Frameworks
  "Automatic detection": "自动检测",
  "Labor Law": "劳动法",
  "Saudization": "沙特化",
  "Contracts": "合同",
  "Termination": "终止",
  "Wages & Benefits": "工资和福利",
  "Leave Policies": "休假政策",
  "Workplace Safety": "工作场所安全",
  
  // Models
  "Claude by Anthropic": "Anthropic 的 Claude",
  "DeepSeek by Groq": "Groq 的 DeepSeek",
  "MJ Lab Mode": "MJ 实验室模式",
  
  // Character count
  "{{remainingChars}} character left": "还剩 {{remainingChars}} 个字符",
  "{{remainingChars}} characters left": "还剩 {{remainingChars}} 个字符",
  
  // Error messages
  "An error occurred": "发生错误",
  "Failed to change language": "更改语言失败",
  "Please try again": "请重试",
  "Connection lost": "连接丢失",
  "Reconnecting...": "重新连接中...",
  "Nothing to clear": "没有内容可清除",
  "All messages cleared": "所有消息已清除",
  "All data cleared": "所有数据已清除",
  "Storage limit reached": "存储限制已达到",
  "Some older messages were removed to save space.": "为节省空间，部分较早的消息已被删除。",
  
  // Additional keys
  "Font Size": "字体大小",
  "Language changed to {locale}": "语言已更改为 {locale}",
  "Select language": "选择语言",
  "Support": "支持",
  
  // Brand names (do not translate)
  "Leen": "Leen",
  
  // Message actions
  "Message copied to clipboard": "消息已复制到剪贴板",
  "Read": "阅读",
  "Summarize": "总结",
  
  // Ice Breakers Dialog
  "Message Suggestions": "消息建议",
  "Select a question to quickly start a conversation about Saudi labor laws.": "选择一个问题，快速开始关于沙特劳动法律的对话。",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "沙特劳动法规定的主要员工权利有哪些？您能提供一个简单的概述吗？",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "关于工作时间、加班和休假，沙特阿拉伯的雇主有哪些义务？",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "沙特劳动法如何处理雇佣终止和离职福利？",
  
  // Audio Player Dialog
  "AI Summary": "AI 摘要",
  "Listen to the summarized response using our AI Service.": "使用我们的 AI 服务聆听摘要回复。",
  "Generating summary...": "正在生成摘要...",
  "Preparing audio...": "正在准备音频...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "文本处理失败。请重试。",
  "Failed to auto-play audio. Click play to try again.": "自动播放音频失败。点击播放重试。",
  "Failed to load audio. Please try again.": "加载音频失败。请重试。",
  "Audio playback was aborted.": "音频播放已中止。",
  "Network error occurred while loading audio.": "加载音频时发生网络错误。",
  "Audio decoding failed.": "音频解码失败。",
  "Audio format not supported.": "不支持的音频格式。",
  "Failed to setup audio playback": "设置音频播放失败",
  "Failed to generate speech": "生成语音失败",
  "Failed to generate audio. Please try again.": "生成音频失败。请重试。",
  "Failed to play audio. Please try again.": "播放音频失败。请重试。",
  
  // Update Notifications
  "update.updateAvailable": "更新可用",
  "update.newVersionAvailable": "新版本 {{version}} 可用",
  "update.refreshToApply": "刷新以应用最新功能和改进",
  "update.later": "稍后",
  "update.updateNow": "立即更新",
  
  // CSAT Feedback
  "We Value Your Feedback": "我们重视您的反馈",
  "Give Feedback": "提供反馈",
  "How would you rate your experience?": "您如何评价您的体验？",
  "Very Dissatisfied": "非常不满意",
  "Dissatisfied": "不满意",
  "Neutral": "一般",
  "Satisfied": "满意",
  "Very Satisfied": "非常满意",
  "Select a rating": "选择评分",
  "Comments or Bug Report": "评论或错误报告",
  "Please share your thoughts or report any issues...": "请分享您的想法或报告任何问题...",
  "Contact Number": "联系电话",
  "Feedback Type": "反馈类型",
  "Select a feedback type": "选择反馈类型",
  "Loading...": "加载中...",
  "No feedback types available": "没有可用的反馈类型", 
  "(Optional)": "（可选）",
  "Feedback Submitted": "反馈已提交",
  "Thank you for your feedback!": "感谢您的反馈！",
  "Rating Required": "需要评分",
  "Please select a rating before submitting.": "提交前请选择评分。",
  "Submit Feedback": "提交反馈",
  "Submitting...": "提交中...",
  "General": "一般",
  "Bug": "错误",
  "Idea": "想法",
  
  // Feedback Dashboard
  "Feedback Dashboard": "反馈仪表板",
  "Total Feedbacks": "反馈总数",
  "All-time submissions": "所有提交",
  "Average Rating": "平均评分",
  "Out of 5 stars": "满分5星",
  "Feedback with Comments": "带评论的反馈",
  "Detailed feedback": "详细反馈",
  "Rating Distribution": "评分分布",
  "Breakdown of user satisfaction": "用户满意度细分",
  "Rating Percentage": "评分百分比",
  "Proportion of each rating": "各评分比例",
  "Responses": "回复",
  "All Feedback": "所有反馈",
  "Detailed view of user submissions": "用户提交的详细视图",
  "ID": "ID",
  "Rating": "评分",
  "Comment": "评论",
  "Contact": "联系方式",
  "Date": "日期",
  "Page": "页面",
  "No feedback data available": "没有可用的反馈数据",
  "No comment": "无评论",
  "Not provided": "未提供",
  "Not available": "不可用",
  
  // Authentication
  "Login": "登录",
  "Register": "注册",
  "Username": "用户名",
  "Password": "密码",
  "Confirm Password": "确认密码",
  "Email": "电子邮件",
  "Full Name": "全名",
  "Don't have an account?": "没有账户？",
  "Already have an account?": "已有账户？",
  "Login to continue": "登录以继续",
  "Create an account": "创建账户",
  "Passwords must match": "密码必须匹配",
  "Invalid email": "无效的电子邮件",
  "Required": "必填",
  "Unauthorized": "未授权",
  "You don't have permission to access this page.": "您没有权限访问此页面。"
};